(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cielohuk-wishlist-root"] && !Shopify.designMode) return;
  try {
    (() => {
    "use strict";

    const root = document.querySelector("[data-cielohuk-wishlist-root]");
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const drawer = document.getElementById("CielohukWishlistDrawer");
    const listContainer = drawer?.querySelector("[data-cielohuk-wishlist-lists]");
    const drawerStatus = drawer?.querySelector("[data-cielohuk-wishlist-status]");
    const retryButton = drawer?.querySelector("[data-cielohuk-wishlist-retry]");
    const globalStatus = root.querySelector("[data-cielohuk-wishlist-global-status]");
    const translationNode = root.querySelector("[data-cielohuk-wishlist-translations]");
    const strings = translationNode ? JSON.parse(translationNode.textContent || "{}") : {};
    const defaultApiBase = "/apps/cielohuk-benefits/v1/wishlist";
    const apiBase = (() => {
      try {
        const url = new URL(root.dataset.apiBase || defaultApiBase, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith("/apps/")) return defaultApiBase;
        return url.pathname.replace(/\/+$/, "");
      } catch {
        return defaultApiBase;
      }
    })();
    const legacyGuestTokenKey = "cielohuk:wishlist:guest-token:v1";
    const guestSessionKey = "cielohuk:wishlist:guest-session:v2";
    const guestRevisionKey = "cielohuk:wishlist:guest-revision:v1";
    const pageSize = 25;
    const productCache = new Map();
    const initialGuestSession = readGuestSession();
    const state = {
      authenticated: root.dataset.authenticated === "true",
      ownerType: null,
      guestToken: initialGuestSession.token,
      guestTokenVersion: initialGuestSession.version,
      revision: 0,
      defaultListId: null,
      lists: [],
      membership: new Map(),
      counts: new Map(),
      ready: null,
      opener: null,
      focusedProductGid: null,
      restoreFocus: true,
      mutationQueue: Promise.resolve(),
      hydrateTimer: null,
      listLoadPromise: null,
      listsLoadedAt: 0,
      drawerLoadPromise: null,
      pageNumber: 1,
    };

    class WishlistApiError extends Error {
      constructor(status, code, message, details) {
        super(message);
        this.name = "WishlistApiError";
        this.status = status;
        this.code = code;
        this.details = details || {};
      }
    }

    function readStorage(key) {
      try {
        return window.localStorage.getItem(key);
      } catch {
        return null;
      }
    }

    function writeStorage(key, value) {
      try {
        if (value === null) window.localStorage.removeItem(key);
        else window.localStorage.setItem(key, String(value));
      } catch {
        return;
      }
    }

    function readGuestSession() {
      const stored = readStorage(guestSessionKey);
      if (stored) {
        try {
          const value = JSON.parse(stored);
          if (
            typeof value?.token === "string" &&
            /^[A-Za-z0-9_-]{43}$/.test(value.token) &&
            Number.isSafeInteger(value.version) &&
            value.version >= 1
          ) {
            return { token: value.token, version: value.version };
          }
        } catch {
          writeStorage(guestSessionKey, null);
        }
      }
      const legacyToken = readStorage(legacyGuestTokenKey);
      if (legacyToken && /^[A-Za-z0-9_-]{43}$/.test(legacyToken)) {
        return { token: legacyToken, version: 0 };
      }
      return { token: null, version: 0 };
    }

    function persistGuestSession(token, version) {
      const nextVersion = Number(version);
      if (
        typeof token !== "string" ||
        !/^[A-Za-z0-9_-]{43}$/.test(token) ||
        !Number.isSafeInteger(nextVersion) ||
        nextVersion < 1
      ) {
        throw new Error("Invalid guest Wishlist session response");
      }
      const current = readGuestSession();
      if (
        current.token &&
        (current.version > nextVersion ||
          (current.version === nextVersion && current.token !== token))
      ) {
        state.guestToken = current.token;
        state.guestTokenVersion = current.version;
        return;
      }
      writeStorage(guestSessionKey, JSON.stringify({ token, version: nextVersion }));
      writeStorage(legacyGuestTokenKey, null);
      state.guestToken = token;
      state.guestTokenVersion = nextVersion;
    }

    function clearGuestSession() {
      state.guestToken = null;
      state.guestTokenVersion = 0;
      writeStorage(guestSessionKey, null);
      writeStorage(legacyGuestTokenKey, null);
      writeStorage(guestRevisionKey, null);
    }

    function formatText(template, values = {}) {
      return Object.entries(values).reduce((text, [key, value]) => {
        const placeholder = ["{", "{", ` ${key} `, "}", "}"].join("");
        return text.replaceAll(placeholder, String(value));
      }, template || "");
    }

    function setStatus(message, isError = false) {
      if (globalStatus) globalStatus.textContent = message;
      if (drawerStatus) {
        drawerStatus.textContent = message;
        drawerStatus.dataset.state = isError ? "error" : "ready";
      }
      if (retryButton) retryButton.hidden = !isError;
    }

    function messageForError(error) {
      if (error instanceof WishlistApiError) {
        if (error.code === "max_items_exceeded") return strings.maxItems;
        if (error.code === "max_lists_exceeded") return strings.maxLists;
        if (error.code === "invalid_list_name" || error.code === "list_name_exists") return strings.listNameError;
        if (error.code === "product_unavailable") return strings.productUnavailable;
        if (error.code === "product_handle_mismatch") return strings.productChanged;
      }
      return strings.unavailable;
    }

    function idempotencyKey(prefix) {
      return `${prefix}:${crypto.randomUUID()}`;
    }

    async function request(path, options = {}) {
      const headers = new Headers({ accept: "application/json" });
      if (options.body !== undefined) headers.set("content-type", "application/json");
      const defaultToken = state.ownerType === "customer" ? null : state.guestToken;
      const token = options.token === undefined ? defaultToken : options.token;
      if (token) headers.set("x-cielohuk-guest-token", token);
      if (options.idempotencyKey) headers.set("idempotency-key", options.idempotencyKey);
      const response = await fetch(`${apiBase}${path}`, {
        method: options.method || "GET",
        headers,
        body: options.body === undefined ? undefined : JSON.stringify(options.body),
        credentials: "same-origin",
        cache: "no-store",
      });
      let payload = null;
      try {
        payload = await response.json();
      } catch {
        payload = null;
      }
      if (!response.ok || !payload || payload.schemaVersion !== 1) {
        const error = payload?.error || {};
        throw new WishlistApiError(
          response.status,
          error.code || "invalid_response",
          error.message || strings.unavailable,
          error.details,
        );
      }
      return payload.data;
    }

    function persistGuestRevision() {
      if (state.ownerType === "guest") writeStorage(guestRevisionKey, state.revision);
    }

    async function mergeGuestWishlist(token, initialGuestRevision) {
      let customerRevision = state.revision;
      let guestRevision = Number.isSafeInteger(initialGuestRevision) ? initialGuestRevision : 0;
      for (let attempt = 0; attempt < 2; attempt += 1) {
        try {
          const merged = await request("/merge", {
            method: "POST",
            token,
            idempotencyKey: idempotencyKey("wishlist-merge"),
            body: {
              expectedCustomerRevision: customerRevision,
              expectedGuestRevision: guestRevision,
            },
          });
          state.revision = merged.revision;
          clearGuestSession();
          return;
        } catch (error) {
          if (
            error instanceof WishlistApiError &&
            error.code === "stale_revision" &&
            attempt === 0
          ) {
            customerRevision = Number(error.details.currentCustomerRevision);
            guestRevision = Number(error.details.currentGuestRevision);
            continue;
          }
          if (
            error instanceof WishlistApiError &&
            ["guest_session_invalid", "guest_session_required"].includes(error.code)
          ) {
            clearGuestSession();
            return;
          }
          throw error;
        }
      }
    }

    async function requestSession(token) {
      return request("/session", {
        method: "POST",
        token: state.authenticated ? null : token,
        body: {},
      });
    }

    async function openSession() {
      const previousToken = state.guestToken;
      const previousGuestRevision = Number(readStorage(guestRevisionKey));
      let session;
      try {
        session = await requestSession(previousToken);
      } catch (error) {
        if (
          !state.authenticated &&
          previousToken &&
          error instanceof WishlistApiError &&
          ["guest_session_invalid", "guest_session_required"].includes(error.code)
        ) {
          clearGuestSession();
          session = await requestSession(null);
        } else {
          throw error;
        }
      }
      state.ownerType = session.ownerType;
      state.revision = session.revision;
      state.defaultListId = session.defaultListId;
      if (session.guestToken) {
        persistGuestSession(session.guestToken, session.guestTokenVersion);
      }
      persistGuestRevision();
      if (session.authenticated && previousToken) {
        try {
          await mergeGuestWishlist(previousToken, previousGuestRevision);
        } catch (error) {
          setStatus(messageForError(error), true);
        }
      }
      await loadLists();
    }

    async function ensureReady(force = false) {
      if (!state.ready || force) {
        state.ready = openSession().catch((error) => {
          state.ready = null;
          throw error;
        });
      }
      return state.ready;
    }

    function rebuildMembershipFromLists() {
      const membership = new Map();
      for (const list of state.lists) {
        for (const item of list.items || []) {
          const listIds = membership.get(item.productGid) || [];
          if (!listIds.includes(list.id)) listIds.push(list.id);
          membership.set(item.productGid, listIds);
        }
      }
      state.membership = membership;
      updateOwnerTotals();
    }

    async function loadLists() {
      if (state.listLoadPromise) return state.listLoadPromise;
      const pending = request("/lists")
        .then((data) => {
          state.revision = Number.isSafeInteger(data.revision) ? data.revision : state.revision;
          state.lists = Array.isArray(data.lists) ? data.lists : [];
          const defaultList = state.lists.find((list) => list.isDefault);
          if (defaultList) state.defaultListId = defaultList.id;
          rebuildMembershipFromLists();
          persistGuestRevision();
          state.listsLoadedAt = Date.now();
          return data;
        })
        .finally(() => {
          if (state.listLoadPromise === pending) state.listLoadPromise = null;
        });
      state.listLoadPromise = pending;
      return pending;
    }

    function updateOwnerTotals() {
      const total = [...state.membership.values()].filter(
        (listIds) => Array.isArray(listIds) && listIds.length > 0,
      ).length;
      document.querySelectorAll("[data-cielohuk-wishlist-total]").forEach((node) => {
        node.textContent = String(total);
      });
      document.querySelectorAll("[data-cielohuk-wishlist-drawer-summary]").forEach((node) => {
        node.textContent = formatText(strings.pageSummary, { count: total });
      });
    }

    function chunks(values, size) {
      const output = [];
      for (let index = 0; index < values.length; index += size) {
        output.push(values.slice(index, index + size));
      }
      return output;
    }

    async function readVisibleMembership(productGids) {
      for (const productChunk of chunks(productGids, 250)) {
        const data = await request("/membership", {
          method: "POST",
          body: { products: productChunk },
        });
        state.revision = Number.isSafeInteger(data.revision) ? data.revision : state.revision;
        for (const product of data.products || []) {
          state.membership.set(product.productGid, Array.isArray(product.listIds) ? product.listIds : []);
        }
      }
      persistGuestRevision();
    }

    async function readVisibleCounts(productGids) {
      if (root.dataset.countEnabled !== "true") return;
      for (const productChunk of chunks(productGids, 250)) {
        const data = await request("/counts", {
          method: "POST",
          body: { products: productChunk },
        });
        for (const product of data.products || []) {
          if (Number.isSafeInteger(product.displayCount) && product.displayCount >= 0) {
            state.counts.set(product.productGid, product.displayCount);
          }
        }
      }
    }

    function relocateCardButton(button) {
      const card = button.closest(".hdt-card-product");
      const media = card?.querySelector(".hdt-card-product__media");
      if (!media) return;
      button.classList.add("cielohuk-wishlist-button--card");
      if (button.parentElement !== media) media.append(button);
    }

    function updateButton(button) {
      const productGid = button.dataset.productGid;
      if (!productGid) return;
      relocateCardButton(button);
      const hydrationState = button.dataset.cielohukWishlistHydration;
      const included = (state.membership.get(productGid) || []).length > 0;
      const label = included ? strings.remove : strings.add;
      const count = state.counts.get(productGid);
      const threshold = Number(root.dataset.countThreshold || 0);
      const countNode = button.querySelector("[data-cielohuk-wishlist-count]");
      const safeCount = Number.isSafeInteger(count) && count >= 0 ? count : 0;
      const showCount = root.dataset.countEnabled === "true" && safeCount > 0 && safeCount >= threshold;
      button.setAttribute("aria-pressed", included ? "true" : "false");
      button.setAttribute("action", included ? "added" : "add");
      button.dataset.included = included ? "true" : "false";
      const labelNode = button.querySelector("[data-cielohuk-wishlist-label]");
      if (labelNode) labelNode.textContent = label;
      if (countNode) {
        countNode.textContent = String(safeCount);
        countNode.hidden = !showCount;
      }
      const countLabel = showCount ? `, ${formatText(strings.publicCount, { count: safeCount })}` : "";
      button.setAttribute("aria-label", `${label}${countLabel}`);
      button.dataset.cielohukWishlistHydration = "ready";
      button.disabled = false;
      if (hydrationState !== "ready") button.removeAttribute("aria-busy");
    }

    function updateAllButtons() {
      document.querySelectorAll("[data-cielohuk-wishlist-toggle]").forEach(updateButton);
    }

    function markProductControlsUnavailable(buttons = document.querySelectorAll("[data-cielohuk-wishlist-toggle]")) {
      buttons.forEach((button) => {
        if (button.dataset.cielohukWishlistHydration !== "pending") return;
        relocateCardButton(button);
        button.dataset.cielohukWishlistHydration = "error";
        button.setAttribute("action", "error");
        button.removeAttribute("aria-pressed");
        button.removeAttribute("aria-busy");
        delete button.dataset.included;
        button.disabled = true;
        const labelNode = button.querySelector("[data-cielohuk-wishlist-label]");
        const countNode = button.querySelector("[data-cielohuk-wishlist-count]");
        if (labelNode) labelNode.textContent = strings.unavailable;
        if (countNode) countNode.hidden = true;
        button.setAttribute("aria-label", strings.unavailable);
      });
    }

    async function hydrateProductControls() {
      const buttons = [...document.querySelectorAll("[data-cielohuk-wishlist-toggle]")];
      buttons.forEach(relocateCardButton);
      const productGids = [...new Set(buttons.map((button) => button.dataset.productGid).filter(Boolean))];
      if (productGids.length === 0) return;
      try {
        const membership = state.authenticated || state.guestToken || state.ownerType
          ? ensureReady().then(() => readVisibleMembership(productGids))
          : Promise.resolve();
        const results = await Promise.allSettled([membership, readVisibleCounts(productGids)]);
        if (results[0].status === "rejected") {
          markProductControlsUnavailable(buttons);
          throw results[0].reason;
        }
        updateAllButtons();
      } catch (error) {
        setStatus(messageForError(error), true);
      }
    }

    function scheduleHydrate() {
      window.clearTimeout(state.hydrateTimer);
      state.hydrateTimer = window.setTimeout(() => void hydrateProductControls(), 40);
    }

    async function itemMutation(method, listId, product, allowRetry = true) {
      try {
        const body = {
          productGid: product.productGid,
          expectedRevision: state.revision,
        };
        if (method === "PUT") {
          body.preferredVariantGid = product.preferredVariantGid || null;
          body.productHandle = product.productHandle || null;
          body.source = product.source || "card";
        }
        const result = await request(`/lists/${encodeURIComponent(listId)}/items`, {
          method,
          idempotencyKey: idempotencyKey(method === "PUT" ? "wishlist-add" : "wishlist-remove"),
          body,
        });
        state.revision = result.revision;
        persistGuestRevision();
        return result;
      } catch (error) {
        if (
          allowRetry &&
          error instanceof WishlistApiError &&
          error.code === "stale_revision"
        ) {
          await loadLists();
          return itemMutation(method, listId, product, false);
        }
        throw error;
      }
    }

    async function deleteProductMutation(productGid, allowRetry = true) {
      try {
        const result = await request("/items", {
          method: "DELETE",
          idempotencyKey: idempotencyKey("wishlist-remove-all"),
          body: {
            productGid,
            expectedRevision: state.revision,
          },
        });
        state.revision = result.revision;
        persistGuestRevision();
        return result;
      } catch (error) {
        if (
          allowRetry &&
          error instanceof WishlistApiError &&
          error.code === "stale_revision"
        ) {
          await loadLists();
          return deleteProductMutation(productGid, false);
        }
        throw error;
      }
    }

    function enqueueMutation(operation) {
      const run = state.mutationQueue.catch(() => undefined).then(operation);
      state.mutationQueue = run.catch(() => undefined);
      return run;
    }

    function productFromButton(button) {
      return {
        productGid: button.dataset.productGid,
        productHandle: button.dataset.productHandle || null,
        preferredVariantGid: button.dataset.variantGid || null,
        source: button.dataset.source || "card",
      };
    }

    async function addFromButton(button) {
      button.setAttribute("aria-busy", "true");
      setStatus(strings.saving);
      try {
        await ensureReady();
        const product = productFromButton(button);
        await itemMutation("PUT", state.defaultListId, product);
        await loadLists();
        await readVisibleCounts([product.productGid]).catch(() => undefined);
        updateAllButtons();
        setStatus(strings.saved);
        broadcastUpdate();
      } catch (error) {
        setStatus(messageForError(error), true);
      } finally {
        button.removeAttribute("aria-busy");
      }
    }

    async function removeProductEverywhere(button) {
      button.setAttribute("aria-busy", "true");
      setStatus(strings.saving);
      try {
        await ensureReady();
        const product = productFromButton(button);
        await removeProductGidEverywhere(product.productGid);
      } catch (error) {
        setStatus(messageForError(error), true);
      } finally {
        button.removeAttribute("aria-busy");
      }
    }

    function createElement(tagName, className, text) {
      const element = document.createElement(tagName);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }

    function productPath(handle) {
      return `/products/${encodeURIComponent(handle || "")}`;
    }

    function numericGid(gid) {
      const value = String(gid || "").split("/").pop();
      return /^\d+$/.test(value || "") ? value : null;
    }

    function formatMoney(cents) {
      if (!Number.isFinite(cents)) return "";
      try {
        return new Intl.NumberFormat(root.dataset.locale || "ja-JP", {
          style: "currency",
          currency: root.dataset.currency || "JPY",
          maximumFractionDigits: 0,
        }).format(cents / 100);
      } catch {
        return String(cents);
      }
    }

    async function loadProduct(handle) {
      if (!handle) return null;
      if (!productCache.has(handle)) {
        productCache.set(
          handle,
          fetch(`${productPath(handle)}.js`, {
            headers: { accept: "application/json" },
            credentials: "same-origin",
            cache: "force-cache",
          })
            .then((response) => {
              if (!response.ok) throw new Error("product_unavailable");
              return response.json();
            })
            .catch(() => null),
        );
      }
      return productCache.get(handle);
    }

    function safeImageUrl(value) {
      if (typeof value !== "string" || value.length === 0) return null;
      try {
        const url = new URL(value, window.location.origin);
        return ["http:", "https:"].includes(url.protocol) ? url.href : null;
      } catch {
        return null;
      }
    }

    async function enrichDrawerItem(item, elements) {
      const product = await loadProduct(item.productHandle);
      if (!product) return;
      elements.title.textContent = product.title || item.productHandle;
      const imageUrl = safeImageUrl(product.featured_image);
      if (imageUrl) {
        const image = createElement("img");
        image.src = imageUrl;
        image.alt = product.title || "";
        image.loading = "lazy";
        elements.media.replaceChildren(image);
      }
      elements.price.textContent = formatMoney(product.price);
      const preferredId = numericGid(item.preferredVariantGid);
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variant =
        variants.find((candidate) => String(candidate.id) === preferredId && candidate.available) ||
        variants.find((candidate) => candidate.available);
      if (variant) {
        elements.variantInput.value = String(variant.id);
        elements.cartButton.disabled = false;
      } else {
        elements.cartButton.textContent = strings.soldOut;
      }
    }

    function createQuantityControl(className = "cielohuk-wishlist-quantity") {
      const wrapper = createElement("div", className);
      wrapper.dataset.cielohukQuantity = "true";
      const decrease = createElement("button", "", "−");
      decrease.type = "button";
      decrease.dataset.cielohukQuantityStep = "-1";
      decrease.setAttribute("aria-label", strings.decreaseQuantity);
      const input = createElement("input");
      input.type = "number";
      input.name = "quantity";
      input.min = "1";
      input.step = "1";
      input.inputMode = "numeric";
      input.value = "1";
      input.setAttribute("aria-label", strings.quantity);
      const increase = createElement("button", "", "+");
      increase.type = "button";
      increase.dataset.cielohukQuantityStep = "1";
      increase.setAttribute("aria-label", strings.increaseQuantity);
      wrapper.append(decrease, input, increase);
      return { wrapper, input };
    }

    function drawerItem(item, enrichmentAllowed) {
      const row = createElement("li", "cielohuk-wishlist-item");
      row.dataset.productGid = item.productGid;
      const media = createElement("div", "cielohuk-wishlist-item__media");
      const content = createElement("div", "cielohuk-wishlist-item__content");
      const title = createElement("a", "cielohuk-wishlist-item__title", (item.productHandle || "").replaceAll("-", " "));
      title.href = productPath(item.productHandle);
      const price = createElement("p", "cielohuk-wishlist-item__price", "");
      const actions = createElement("div", "cielohuk-wishlist-item__actions");
      const viewLink = createElement("a", "cielohuk-wishlist-item__view", strings.viewProduct);
      viewLink.href = productPath(item.productHandle);
      const remove = createElement("button", "cielohuk-wishlist-item__remove", strings.removeItem);
      remove.type = "button";
      remove.dataset.cielohukWishlistRemoveAll = "true";
      remove.dataset.productGid = item.productGid;
      const cartForm = createElement("form", "cielohuk-wishlist-item__cart");
      cartForm.method = "post";
      cartForm.action = root.dataset.cartAddUrl || "/cart/add";
      const variantInput = createElement("input");
      variantInput.type = "hidden";
      variantInput.name = "id";
      const quantity = createQuantityControl();
      const cartButton = createElement("button", "", strings.addToCart);
      cartButton.type = "submit";
      cartButton.disabled = true;
      cartForm.append(variantInput, quantity.wrapper, cartButton);
      actions.append(viewLink, remove, cartForm);
      content.append(title, price, actions);
      row.append(media, content);

      if (enrichmentAllowed) {
        void enrichDrawerItem(item, { media, title, price, variantInput, cartButton });
      }
      return row;
    }

    function renderDrawer() {
      if (!listContainer) return;
      listContainer.replaceChildren();
      const panel = createElement("div", "cielohuk-wishlist-list cielohuk-wishlist-list--single");
      const products = orderedWishlistProducts();
      let enrichmentCount = 0;
      if (products.length === 0) {
        panel.append(createElement("p", "cielohuk-wishlist-list__empty", strings.emptyList));
      } else {
        const items = createElement("ul", "cielohuk-wishlist-items");
        for (const item of products) {
          const allowEnrichment = productCache.has(item.productHandle) || enrichmentCount < 30;
          if (!productCache.has(item.productHandle) && allowEnrichment) enrichmentCount += 1;
          items.append(drawerItem(item, allowEnrichment));
        }
        panel.append(items);
      }
      listContainer.append(panel);
      updateOwnerTotals();
      if (drawer?.open && !drawer.contains(document.activeElement)) {
        drawer.querySelector("[data-cielohuk-wishlist-close]")?.focus({ preventScroll: true });
      }
    }

    async function openDrawer(opener, productGid = null) {
      if (!drawer) return;
      state.opener = opener || document.activeElement;
      state.focusedProductGid = productGid;
      state.restoreFocus = true;
      if (!drawer.open) {
        if (typeof drawer.showModal === "function") drawer.showModal();
        else drawer.setAttribute("open", "");
      }
      document.body.classList.add("cielohuk-wishlist-drawer-open");
      if (state.listsLoadedAt > 0) {
        renderDrawer();
        setStatus("");
      } else {
        setStatus(strings.loading);
      }
      if (state.drawerLoadPromise) return state.drawerLoadPromise;
      drawer.setAttribute("aria-busy", "true");
      const pending = (async () => {
        try {
          await ensureReady();
          if (Date.now() - state.listsLoadedAt > 15000) await loadLists();
          renderDrawer();
          setStatus("");
        } catch (error) {
          setStatus(messageForError(error), true);
        } finally {
          drawer.removeAttribute("aria-busy");
          if (state.drawerLoadPromise === pending) state.drawerLoadPromise = null;
        }
      })();
      state.drawerLoadPromise = pending;
      return pending;
    }

    function closeDrawer(restoreFocus = true) {
      if (!drawer) return;
      state.restoreFocus = restoreFocus;
      if (typeof drawer.close === "function") drawer.close();
      else drawer.removeAttribute("open");
    }

    function drawerFocusableElements() {
      if (!drawer) return [];
      const selector = [
        "a[href]",
        "button:not([disabled])",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        '[tabindex]:not([tabindex="-1"])',
      ].join(",");
      return [...drawer.querySelectorAll(selector)].filter(
        (element) =>
          element instanceof HTMLElement &&
          !element.hidden &&
          !element.closest('[hidden], [aria-hidden="true"]') &&
          element.getClientRects().length > 0,
      );
    }

    function trapDrawerFocus(event) {
      if (event.key !== "Tab" || !drawer?.open) return;
      const focusable = drawerFocusableElements();
      if (focusable.length === 0) {
        event.preventDefault();
        drawer.focus({ preventScroll: true });
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !drawer.contains(active))) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && (active === last || !drawer.contains(active))) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }

    function orderedWishlistProducts() {
      const seen = new Set();
      const products = [];
      for (const list of state.lists) {
        for (const item of list.items || []) {
          if (!seen.has(item.productGid)) {
            seen.add(item.productGid);
            products.push(item);
          }
        }
      }
      return products;
    }

    async function enrichWishlistPageItem(item, elements) {
      const product = await loadProduct(item.productHandle);
      if (!product) {
        elements.availability.textContent = strings.soldOut;
        return;
      }
      const path = productPath(item.productHandle);
      elements.title.textContent = product.title || item.productHandle;
      elements.title.href = path;
      elements.media.href = path;
      elements.view.href = path;
      const imageUrl = safeImageUrl(product.featured_image);
      if (imageUrl) {
        const image = createElement("img");
        image.src = imageUrl;
        image.alt = product.title || "";
        image.loading = "lazy";
        elements.media.replaceChildren(image);
      }
      elements.price.textContent = formatMoney(product.price);
      const preferredId = numericGid(item.preferredVariantGid);
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variant =
        variants.find((candidate) => String(candidate.id) === preferredId && candidate.available) ||
        variants.find((candidate) => candidate.available);
      if (variant) {
        elements.variantInput.value = String(variant.id);
        elements.cartButton.disabled = false;
        elements.availability.textContent = strings.inStock;
      } else {
        elements.cartButton.textContent = strings.soldOut;
        elements.availability.textContent = strings.soldOut;
      }
    }

    function wishlistPageItem(item) {
      const row = createElement("li", "cielohuk-wishlist-page__item");
      row.dataset.productGid = item.productGid;
      const media = createElement("a", "cielohuk-wishlist-page__media");
      media.href = productPath(item.productHandle);
      media.setAttribute("aria-label", strings.viewProduct);
      const content = createElement("div", "cielohuk-wishlist-page__content");
      const title = createElement(
        "a",
        "cielohuk-wishlist-page__title",
        (item.productHandle || "").replaceAll("-", " "),
      );
      title.href = productPath(item.productHandle);
      const price = createElement("p", "cielohuk-wishlist-page__price", "");
      const availability = createElement("p", "cielohuk-wishlist-page__availability", strings.pageLoading);
      const actions = createElement("div", "cielohuk-wishlist-page__actions");
      const links = createElement("div", "cielohuk-wishlist-page__links");
      const view = createElement("a", "cielohuk-wishlist-page__view", strings.viewProduct);
      view.href = productPath(item.productHandle);
      const remove = createElement("button", "cielohuk-wishlist-page__remove", strings.removeItem);
      remove.type = "button";
      remove.dataset.cielohukWishlistRemoveAll = "true";
      remove.dataset.productGid = item.productGid;
      const cartForm = createElement("form", "cielohuk-wishlist-page__cart");
      cartForm.method = "post";
      cartForm.action = root.dataset.cartAddUrl || "/cart/add";
      const variantInput = createElement("input");
      variantInput.type = "hidden";
      variantInput.name = "id";
      const quantity = createQuantityControl();
      const cartButton = createElement("button", "", strings.addToCart);
      cartButton.type = "submit";
      cartButton.disabled = true;
      cartForm.append(variantInput, quantity.wrapper, cartButton);
      links.append(view, remove);
      actions.append(links, cartForm);
      content.append(title, price, availability, actions);
      row.append(media, content);
      void enrichWishlistPageItem(item, {
        media,
        title,
        price,
        availability,
        view,
        variantInput,
        cartButton,
      });
      return row;
    }

    function renderWishlistPagination(container, currentPage, totalPages) {
      if (!container) return;
      container.replaceChildren();
      if (totalPages <= 1) return;
      const previous = createElement("button", "", strings.previousPage);
      previous.type = "button";
      previous.disabled = currentPage <= 1;
      previous.addEventListener("click", () => {
        state.pageNumber = Math.max(1, currentPage - 1);
        void syncWishlistPage();
      });
      const status = createElement("span", "", formatText(strings.pageStatus, { current: currentPage, total: totalPages }));
      const next = createElement("button", "", strings.nextPage);
      next.type = "button";
      next.disabled = currentPage >= totalPages;
      next.addEventListener("click", () => {
        state.pageNumber = Math.min(totalPages, currentPage + 1);
        void syncWishlistPage();
      });
      container.append(previous, status, next);
    }

    async function syncWishlistPage() {
      const page = document.querySelector("[data-cielohuk-wishlist-page]");
      if (!page) return;
      const loading = page.querySelector("[data-cielohuk-wishlist-page-loading]");
      const feedback = page.querySelector("[data-cielohuk-wishlist-page-feedback]");
      const empty = page.querySelector("[data-cielohuk-wishlist-page-empty]");
      const items = page.querySelector("[data-cielohuk-wishlist-page-items]");
      const pagination = page.querySelector("[data-cielohuk-wishlist-pagination]");
      const summary = page.querySelector("[data-cielohuk-wishlist-page-summary]");
      const products = orderedWishlistProducts();
      if (summary) summary.textContent = formatText(strings.pageSummary, { count: products.length });
      if (products.length === 0) {
        if (items) {
          items.hidden = true;
          items.replaceChildren();
        }
        if (empty) empty.hidden = false;
        if (loading) loading.hidden = true;
        if (feedback) feedback.hidden = true;
        page.dataset.ready = "true";
        state.pageNumber = 1;
        renderWishlistPagination(pagination, 1, 1);
        return;
      }
      if (empty) empty.hidden = true;
      const totalPages = Math.max(1, Math.ceil(products.length / pageSize));
      state.pageNumber = Math.min(Math.max(state.pageNumber, 1), totalPages);
      const selected = products.slice(
        (state.pageNumber - 1) * pageSize,
        state.pageNumber * pageSize,
      );
      if (items) {
        items.replaceChildren(...selected.map(wishlistPageItem));
        items.hidden = false;
      }
      renderWishlistPagination(pagination, state.pageNumber, totalPages);
      if (loading) loading.hidden = true;
      if (feedback) feedback.hidden = true;
      page.dataset.ready = "true";
    }

    function broadcastUpdate() {
      if (channel) channel.postMessage({ type: "wishlist-updated" });
    }

    async function removeProductGidEverywhere(productGid) {
      await ensureReady();
      const result = await deleteProductMutation(productGid);
      for (const list of state.lists) {
        if (Array.isArray(list.items)) {
          list.items = list.items.filter((item) => item.productGid !== productGid);
        }
      }
      state.membership.delete(productGid);
      if (result.changed) {
        const count = state.counts.get(productGid);
        if (Number.isSafeInteger(count) && count > 0) {
          state.counts.set(productGid, count - 1);
        }
      }
      renderDrawer();
      updateAllButtons();
      setStatus(strings.itemRemoved);
      broadcastUpdate();
      await syncWishlistPage();
      void readVisibleCounts([productGid])
        .then(updateAllButtons)
        .catch(() => undefined);
    }

    async function refreshFromServer() {
      const page = document.querySelector("[data-cielohuk-wishlist-page]");
      const feedback = page?.querySelector("[data-cielohuk-wishlist-page-feedback]");
      const loading = page?.querySelector("[data-cielohuk-wishlist-page-loading]");
      const pageRetry = page?.querySelector("[data-cielohuk-wishlist-retry]");
      if (feedback) feedback.hidden = false;
      if (loading) {
        loading.hidden = false;
        loading.textContent = strings.pageLoading;
      }
      if (pageRetry) pageRetry.hidden = true;
      try {
        const sessionWasReady = Boolean(state.ready);
        await ensureReady();
        if (sessionWasReady || state.listsLoadedAt === 0) await loadLists();
        renderDrawer();
        updateAllButtons();
        scheduleHydrate();
        await syncWishlistPage();
      } catch (error) {
        setStatus(messageForError(error), true);
        if (page) page.dataset.ready = "true";
        if (loading) loading.textContent = messageForError(error);
        if (pageRetry) pageRetry.hidden = false;
      }
    }

    const channel = "BroadcastChannel" in window ? new BroadcastChannel("cielohuk-wishlist-v1") : null;
    if (channel) channel.addEventListener("message", () => void refreshFromServer());

    document.addEventListener("click", (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const quantityStep = target?.closest("[data-cielohuk-quantity-step]");
      if (quantityStep) {
        event.preventDefault();
        const quantity = quantityStep
          .closest("[data-cielohuk-quantity]")
          ?.querySelector("input[name='quantity']");
        if (quantity instanceof HTMLInputElement) {
          const current = Number.parseInt(quantity.value, 10);
          const step = Number.parseInt(quantityStep.dataset.cielohukQuantityStep || "0", 10);
          quantity.value = String(Math.max(1, (Number.isFinite(current) ? current : 1) + step));
        }
        return;
      }

      const pageRemove = target?.closest("[data-cielohuk-wishlist-remove-all]");
      if (pageRemove) {
        const productGid = pageRemove.dataset.productGid;
        if (!productGid) return;
        pageRemove.disabled = true;
        pageRemove.setAttribute("aria-busy", "true");
        void enqueueMutation(async () => {
          setStatus(strings.saving);
          try {
            await removeProductGidEverywhere(productGid);
          } catch (error) {
            setStatus(messageForError(error), true);
            pageRemove.disabled = false;
            pageRemove.removeAttribute("aria-busy");
          }
        });
        return;
      }

      const toggle = target?.closest("[data-cielohuk-wishlist-toggle]");
      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        if (toggle.hasAttribute("data-wishlist-remove-on-page")) {
          void enqueueMutation(() => removeProductEverywhere(toggle));
        } else if (toggle.dataset.included === "true") {
          void enqueueMutation(() => removeProductEverywhere(toggle));
        } else {
          void enqueueMutation(() => addFromButton(toggle));
        }
        return;
      }

      const launcher = target?.closest("[data-cielohuk-wishlist-open]");
      if (launcher) {
        event.preventDefault();
        void openDrawer(launcher);
        return;
      }

      if (target?.closest("[data-cielohuk-wishlist-retry]")) {
        void refreshFromServer();
        return;
      }

      if (target?.closest("[data-cielohuk-wishlist-close]")) {
        closeDrawer();
        return;
      }

    });

    document.addEventListener("change", (event) => {
      const field = event.target instanceof Element ? event.target.closest("[name='id']") : null;
      if (!field) return;
      window.queueMicrotask(() => {
        const scope = field.closest("form")?.closest("section, [id*='Product'], hdt-quick-view") || document;
        scope.querySelectorAll("[data-cielohuk-wishlist-toggle]").forEach((button) => {
          const value = field.value;
          if (/^\d+$/.test(value)) button.dataset.variantGid = `gid://shopify/ProductVariant/${value}`;
        });
      });
    });

    if (drawer) {
      drawer.addEventListener("keydown", trapDrawerFocus);
      drawer.addEventListener("click", (event) => {
        if (event.target === drawer) closeDrawer();
      });
      drawer.addEventListener("close", () => {
        document.body.classList.remove("cielohuk-wishlist-drawer-open");
        if (state.restoreFocus && state.opener instanceof HTMLElement) state.opener.focus({ preventScroll: true });
        state.restoreFocus = true;
      });
    }

    window.addEventListener("storage", (event) => {
      if (![guestSessionKey, legacyGuestTokenKey, guestRevisionKey].includes(event.key)) return;
      if ([guestSessionKey, legacyGuestTokenKey].includes(event.key)) {
        const next = readGuestSession();
        if (next.version < state.guestTokenVersion) return;
        const changed =
          next.token !== state.guestToken || next.version !== state.guestTokenVersion;
        if (!changed) return;
        const canRefreshCurrentOwner =
          !state.authenticated && state.ownerType === "guest" && Boolean(state.ready);
        state.guestToken = next.token;
        state.guestTokenVersion = next.version;
        if (!state.authenticated && !next.token) {
          state.ownerType = null;
          state.ready = null;
          state.lists = [];
          state.membership = new Map();
          updateOwnerTotals();
          updateAllButtons();
          void syncWishlistPage();
          return;
        }
        if (canRefreshCurrentOwner) {
          void refreshFromServer();
        } else {
          state.ownerType = null;
          state.ready = null;
        }
        return;
      }
      void refreshFromServer();
    });
    document.addEventListener("shopify:section:load", scheduleHydrate);
    new MutationObserver((records) => {
      const hasNewWishlistControl = records.some((record) =>
        [...record.addedNodes].some(
          (node) =>
            node instanceof Element &&
            (node.matches("[data-cielohuk-wishlist-toggle]") ||
              node.querySelector("[data-cielohuk-wishlist-toggle]")),
        ),
      );
      if (hasNewWishlistControl) scheduleHydrate();
    }).observe(document.body, { childList: true, subtree: true });

    const hasWishlistPage = Boolean(document.querySelector("[data-cielohuk-wishlist-page]"));
    const existingOwnerReady =
      state.authenticated || state.guestToken || hasWishlistPage
        ? ensureReady()
        : Promise.resolve();
    void existingOwnerReady
      .then(async () => {
        setStatus("");
        renderDrawer();
        await hydrateProductControls();
        await syncWishlistPage();
      })
      .catch((error) => {
        markProductControlsUnavailable();
        setStatus(messageForError(error), true);
        const page = document.querySelector("[data-cielohuk-wishlist-page]");
        const loading = page?.querySelector("[data-cielohuk-wishlist-page-loading]");
        const retry = page?.querySelector("[data-cielohuk-wishlist-retry]");
        if (loading) loading.textContent = strings.unavailable;
        if (retry) retry.hidden = false;
        if (page) page.dataset.ready = "true";
      });
  })();
  } catch(e) { console.error(e); }
})();

})();
